import React, { FC, useState } from 'react'
import { Icon, Accordion } from 'semantic-ui-react';

import Utility from '../../../Utility';

type Props = {
  title: string
  name: string
  description: string
}
// ok
const BookingDetailsAccordion: FC<Props> = ({
                                              title = '', name = '', description = ''// mais moi je veux carrement pas appeler le composant si SelectedBooking n'a pas les bonne infos du style cancellationId
                                            }) => {
  const [activeIndex, setActiveIndex] = useState<number>(-1)

  const handleClick= (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index

    setActiveIndex(newIndex)
  }

  return (
    <Accordion fluid styled>
      <Accordion.Title
        active={activeIndex === 0}
        index={0}
        onClick={handleClick}
      >
        <div className="d-flex justify-content-between">
          <Icon name='dropdown' />
          <div style={{flex: '1'}}>
            <h5>{title}</h5>
          </div>

        </div>
      </Accordion.Title>
      <Accordion.Content active={activeIndex === 0}>
        <h5 style={{paddingLeft: "0.5em", marginBottom: "0"}}>{name}</h5>
        <div className='p-2' style={{maxHeight: 250, overflow: 'auto'}}>
          {description}
        </div>
      </Accordion.Content>
    </Accordion>
  )
}

export default BookingDetailsAccordion